import type { BreadcrumbItem, ProductItem } from "@edco/apollo";

export function productItemToBreadcrumb ( product: ProductItem ): BreadcrumbItem {
  return {
    id: product.id,
    name: product.name,
    url: product.url,
  };
}
